import { useTranslation } from "react-i18next";

function CareerDetails(props) {
    const data = props?.data;
    const {t} = useTranslation();
    return (
        <div>
            <p><strong>{t("education")}:</strong> {data?.education}</p>
            <p><strong>{t("workExperience")}:</strong> {data?.work_experience}</p>

            <p className="mb-1"><strong>{t("jobScope")}:</strong></p>
            <ul className="ul-no-format">
                {
                    data?.job_scope && data.job_scope.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))
                }
            </ul>

            <p className="mb-1"><strong>{t("jobRequirement")}:</strong></p>
            <ul className="ul-no-format">
                {
                    data?.job_requirement && data.job_requirement.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))
                }
            </ul>

            {
                data?.we_provide ?
                <>
                <p className="mb-1"><strong>{t("weProvide")}:</strong></p>
                <ul className="ul-no-format">
                    {
                        data?.we_provide && data.we_provide.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))
                    }
                </ul>
                </>
                : ""
            }

            <p className="mb-1"><strong>{t("ifInterestedPleaseContact")}:</strong></p>
            <ul className="ul-no-format">
                {
                    data?.contact && data.contact.map((item, index) => (
                        <li key={index}>{item.name} {item.contact}</li>
                    ))
                }
            </ul>
        </div>
    )
}  
export default CareerDetails;
